import { BadgeColor, BadgeShape, BadgeSize, BadgeTone } from './badge.types';

export interface BadgeClassConfig {
  size: BadgeSize;
  tone: BadgeTone;
  color?: BadgeColor;
  dotColor?: BadgeColor;
  shape?: BadgeShape;
  shadow?: boolean;
  iconOnly?: boolean;
  iconPosition?: 'start' | 'end';
  iconOnlyShape?: 'default' | 'circle';
  extraClasses?: string[];
}

export function buildBadgeClasses(config: BadgeClassConfig): string {
  return [
    'ntt-badge',
    `ntt-badge--${config.size}`,
    `ntt-badge--tone-${config.tone}`,
    `ntt-badge--shape-${config.shape ?? 'default'}`,
    config.tone === 'color'
      ? `ntt-badge--color-${config.color ?? 'gray'}`
      : null,
    config.dotColor ? `ntt-badge--dot-color-${config.dotColor}` : null,
    config.iconPosition === 'end' ? 'ntt-badge--icon-end' : null,
    config.iconOnlyShape
      ? `ntt-badge--icon-only-shape-${config.iconOnlyShape}`
      : null,
    config.shadow ? 'ntt-badge--shadow' : null,
    config.iconOnly ? 'ntt-badge--icon-only' : null,
    ...(config.extraClasses ?? []),
  ]
    .filter(Boolean)
    .join(' ');
}
